import PropTypes from 'prop-types'
import styles from './Switch.module.css'

export function Switch({
  checked,
  onChange,
  disabled = false,
  id,
  name,
  required = false,
  className = '',
}) {
  const classes = [
    styles.switch,
    disabled ? styles['switch--disabled'] : '',
    className,
  ].filter(Boolean).join(' ')

  return (
    <label className={classes}>
      <input
        className={styles.switch__input}
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
      />
      <span className={styles.switch__track} />
      <span className={styles.switch__thumb} />
    </label>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
}
